$(function () {
  "use strict";

  const $body = $("body");
  const $sidebarPostage = $(".sidebar-postage");

  $(document).on("click", ".show-postage-sidebar", function (env) {
    env.preventDefault();
    $body.addClass("sidebar-postage-open");

    if ($body.hasClass("locationset")) {
      const classAction = $(this).attr("data-display");
      $sidebarPostage.attr("class", "sidebar-postage " + classAction);
    } else {
      $sidebarPostage.attr("class", "sidebar-postage set-location");
    }
  });

  $(document).on("click", ".close-sidebar", function () {
    $body.removeClass("sidebar-postage-open more-info-open");
    $(".result-block").removeClass("mi-open");
  });

  $(document).on("click", ".more-info", function (env) {
    env.preventDefault();
    const $btn = $(this);
    const $block = $btn.closest(".result-block");
    const target = $btn.data("more-info-target");
    const title = $btn.data("more-info-title");

    $(".result-block").removeClass("mi-open");
    $block.addClass("mi-open");

    $(".more-info-panel").hide();
    $('.more-info-panel[data-panel="' + target + '"]').show();
    $(".more-info__title").text(title);

    $body.addClass("more-info-open");
  });

  $(document).on("click", ".shadow-more-info", function () {
    $body.removeClass("more-info-open");
    $(".result-block").removeClass("mi-open");
  });

  $(document).on("click", ".open-store-d", function (env) {
    env.preventDefault();
    const $parent = $(this).parents(".store-brief");

    $($parent.attr("data-shr")).addClass("visible");
    $sidebarPostage.addClass("display-sd");
  });

  $(document).on("click", ".back-to-cc", function () {
    $(".store-details").removeClass("visible");
  });

  $(document).on("click", ".open-store-n", function (env) {
    env.preventDefault();

    const $btn = $(this);
    const $wrapper = $btn.closest(".nearby-store");
    const $container = $wrapper.find(".store-availability-container");

    $container.stop(true, true).slideToggle(200, function () {
      const isOpen = $container.is(":visible");
      $btn.toggleClass("active", isOpen);
      $btn
        .find("span:last")
        .text(isOpen ? "Hide Nearby Stores" : "Show Nearby Stores");
    });
  });

  function isObject(val) {
    return val && typeof val === "object" && val.constructor === Object;
  }

  function renderSuburbResults(localities) {
    const $lists = $("#suburb ul, .search-box-loc ul");
    $lists.html("");
    const items = isObject(localities) ? [localities] : localities;
    items.forEach(function (item) {
      var lat = item.latitude || '';
      var state = item.state || '';
      var long = item.longitude || '';
      var loc = item.location.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
      $lists.append(
        `<li lat="${lat}" state="${state}" long="${long}"><strong>${loc}</strong>, ${(state ? state+', ': '')} ${item.postcode}</li>`
      );
    });
  }

  $(document).on("input", "input.zipcode-i", function () {
    const postcode = $(this).val();
    const $this = $(this);

    if (postcode.length < 4 && $this.data("main-widget")) {
      $(".suburb-select").addClass("hide").removeClass("visible");
      $("#suburb ul").html("");
      return;
    }

    $.ajax({
      url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=8494&deploy=1&compid=1117015&ns-at=AAEJ7tMQVfpNajZhM3XCNh516Td792i56DVDra0TQsYuuvoxJ-g&q="+postcode,
      type: "GET",
      crossDomain: true,
      dataType: "jsonp",
    }).done(function (response) {
      if (response.localities !== "") {
        $(".suburb-select").removeClass("hide").addClass("visible");
        $(".lable-error").addClass("hide");
        renderSuburbResults(response.localities.locality);
      } else {
        $(".lable-error .ptc").text(postcode);
        $(".lable-error").removeClass("hide");
        $(".suburb-select").addClass("hide");
      }
    }).fail(function (xhr, status, error) {
      console.log(status + "; " + error);
    });
  });

  $(document).on("click", ".search-box-loc ul li", function () {
    $(".search-box-loc ul li").removeClass("active");
    $(this).addClass("active");

    const parts = $(this).text().split(",");
    const locationObj = {
      fullLocation: $(this).text().trim(),
      suburb: parts[0].trim(),
      postcode: parts[parts.length-1].replace(" ", "").trim(),
      latitude: $(this).attr("lat").trim(),
      longitude: $(this).attr("long").trim(),
      state: $(this).attr("state").trim(),
    };
    localStorage.setItem("locationData", JSON.stringify(locationObj));
    $("#zipcode").val(locationObj.postcode);

    if ($(this).parents("ul").data("pdp")) {
      $("#deliverytrigger1").click();
      $(".authorised-display").click();
    }

    setTimeout(function () {
      $(".change-btn").click();
    }, 400);
  });

  $(document).on("click", "#suburb ul li", function () {
    setTimeout(function () {
      $(".authorised-display").click();
      $("#deliverytrigger1").click();
      $(".close-sidebar").click();
    }, 800);
  });

  $(document).on("click", "#forget-user-location", function (env) {
    env.preventDefault();
    $(".close-sidebar").click();
    $(".spinner-1").show();

    setTimeout(function () {
      localStorage.removeItem("locationData");
      $("#selectedLocationTop .input-group, body").removeClass("locationset");
      $("#selectedLocation").text("");
      $(".selectedLocation").text("");
      $("#noprice").show();
      $(".delivery-check-result").hide();
      $(".authorised-dealer").hide();
      $(".clickcollect-store div").hide();
      $(".clickcollect-store div:first-child").show();
      $(".showroom-notavailable").hide();
      $(".showroom-availability-text").hide();
      $(".store-availability-container .default-text").show();
      $(".spinner-1").hide();
    }, 1000);
  });

  $(".authorised-display").click();
  $(".spinner-1").hide();

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      $body.removeClass("sidebar-postage-open more-info-open");
    }
  });
});
